/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const InstallAsync: BridgeCommands.Command<
    Types.Nvapp.Driverinstall.InstallAsyncParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverInstall',
    method: 'InstallAsync',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetState: BridgeCommands.Command<
    Types.Nvapp.Driverinstall.InstallerState,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverInstall',
    method: 'SetState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetState: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverinstall.InstallerState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverInstall',
    method: 'GetState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterProgressNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverinstall.Progress
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverInstall',
    method: 'RegisterProgressNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterFormNotification: BridgeCommands.Command<
    {},
    Types.Nvapp.Driverinstall.InstallerState
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverInstall',
    method: 'RegisterFormNotification',
    persistent: true
};

export const Driverinstall = {
InstallAsync,
SetState,
GetState,
RegisterProgressNotification,
RegisterFormNotification
};
